module.exports = __webpack_public_path__ + "5216db28b1655767f86653610e759c73.jpg";